import { VStack } from "@chakra-ui/layout";
import { Link, Text } from "@chakra-ui/react";
import styled from "styled-components";
import { Back } from "../components/button/Back";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";

const SupportPage = () => {
	return (
		<LoggedInLayout width="s">
			<Styles>
				<PageTitle>Hjälp</PageTitle>
				<Back />

				<VStack spacing={"1rem"} align="flex-start">
					<Text>Kontakta oss för eventuella frågor.</Text>
					<Text>
						Telefon{" "}
						<Link color="blue.500" href="tel:08-652 29 00">
							08-652 29 00
						</Link>{" "}
						eller e-post{" "}
						<Link color="blue.500" href="mailto:vikarie@bildapersonal.se">
							vikarie@bildapersonal.se
						</Link>
					</Text>
				</VStack>
			</Styles>
		</LoggedInLayout>
	);
};

export default SupportPage;

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;
